// reCAPTCHA v3 integration for signup form
(function() {
  'use strict';
  
  var siteKey = null;
  var isProcessing = false;
  var handlerAttached = false;
  var form = null;
  var tokenField = null;

  function getSiteKey() {
    if (siteKey) return siteKey;
    
    var recaptchaScript = document.querySelector('script[src*="recaptcha/api.js"]');
    if (!recaptchaScript) {
      return null;
    }
    
    var match = recaptchaScript.src.match(/render=([^&]+)/);
    if (match && match[1]) {
      siteKey = decodeURIComponent(match[1]);
      return siteKey;
    }
    return null;
  }

  function executeRecaptchaAndSubmit() {
    if (isProcessing) {
      return;
    }

    if (tokenField.value && tokenField.value.length > 0) {
      isProcessing = false;
      return true;
    }

    isProcessing = true;

    if (typeof grecaptcha === 'undefined') {
      alert((window.jsAlerts && window.jsAlerts.t("recaptcha_not_loaded")) || "reCAPTCHA ei latautunut. Päivitä sivu.");
      isProcessing = false;
      return false;
    }

    grecaptcha.ready(function() {
      grecaptcha.execute(siteKey, { action: 'signup' }).then(function(token) {
        if (token && token.length > 0) {
          tokenField.value = token;
          isProcessing = false;
          
          // Submit using the original submit method
          if (form._originalSubmit) {
            form._originalSubmit.call(form);
          } else {
            // Create a submit button and click it to trigger normal form flow
            var submitBtn = document.createElement('input');
            submitBtn.type = 'submit';
            submitBtn.style.display = 'none';
            form.appendChild(submitBtn);
            submitBtn.click();
            form.removeChild(submitBtn);
          }
        } else {
          alert((window.jsAlerts && window.jsAlerts.t("recaptcha_verification_failed")) || "reCAPTCHA-vahvistus epäonnistui. Yritä uudelleen.");
          isProcessing = false;
        }
      }).catch(function() {
        alert((window.jsAlerts && window.jsAlerts.t("recaptcha_verification_failed")) || "reCAPTCHA-vahvistus epäonnistui. Yritä uudelleen.");
        isProcessing = false;
      });
    });
    
    return false;
  }

  function handleFormSubmit(e) {
    if (isProcessing) {
      return false;
    }

    if (tokenField && tokenField.value && tokenField.value.length > 0) {
      return true;
    }

    if (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
    }

    executeRecaptchaAndSubmit();
    return false;
  }

  function initRecaptcha() {
    if (handlerAttached) {
      return;
    }

    form = document.getElementById('registration-form');
    if (!form) {
      return;
    }

    tokenField = document.getElementById('recaptcha_token');
    if (!tokenField) {
      return;
    }

    var key = getSiteKey();
    if (!key) {
      return;
    }

    // Override form.submit() method
    var originalSubmit = form.submit;
    form.submit = function() {
      if (!isProcessing && (!tokenField.value || tokenField.value.length === 0)) {
        executeRecaptchaAndSubmit();
        return;
      }
      originalSubmit.call(form);
    };

    // Add event listener with highest priority (capture phase)
    form.addEventListener('submit', handleFormSubmit, true);

    // jQuery handler if available
    if (typeof jQuery !== 'undefined') {
      jQuery(form).off('submit.recaptcha').on('submit.recaptcha', handleFormSubmit);
    }

    // Intercept button clicks and disable until token is ready
    var submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) {
      // Disable button initially if no token
      if (!tokenField.value || tokenField.value.length === 0) {
        submitButton.disabled = false; // Keep enabled but intercept
      }
      
      submitButton.addEventListener('click', function(e) {
        if (!tokenField.value || tokenField.value.length === 0) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          handleFormSubmit(e);
          return false;
        }
      }, true);
      
      // Also handle jQuery clicks if available
      if (typeof jQuery !== 'undefined') {
        jQuery(submitButton).off('click.recaptcha').on('click.recaptcha', function(e) {
          if (!tokenField.value || tokenField.value.length === 0) {
            e.preventDefault();
            e.stopImmediatePropagation();
            handleFormSubmit(e);
            return false;
          }
        });
      }
    }

    handlerAttached = true;
  }

  function startInit() {
    var form = document.getElementById('registration-form');
    if (!form) {
      return;
    }

    var script = document.querySelector('script[src*="recaptcha/api.js"]');
    if (script) {
      // Wait for grecaptcha to be available
      var grecaptchaCheck = setInterval(function() {
        if (typeof grecaptcha !== 'undefined') {
          clearInterval(grecaptchaCheck);
          initRecaptcha();
        }
      }, 50);
      
      // Timeout after 5 seconds
      setTimeout(function() {
        clearInterval(grecaptchaCheck);
        initRecaptcha(); // Try anyway
      }, 5000);
    } else {
      var checkCount = 0;
      var maxChecks = 100;
      var checkInterval = setInterval(function() {
        checkCount++;
        script = document.querySelector('script[src*="recaptcha/api.js"]');
        if (script || checkCount >= maxChecks) {
          clearInterval(checkInterval);
          setTimeout(function() {
            var grecaptchaCheck = setInterval(function() {
              if (typeof grecaptcha !== 'undefined') {
                clearInterval(grecaptchaCheck);
                initRecaptcha();
              }
            }, 50);
            setTimeout(function() {
              clearInterval(grecaptchaCheck);
              initRecaptcha();
            }, 5000);
          }, 100);
        }
      }, 100);
    }
  }

  // Initialize immediately if DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startInit);
  } else {
    startInit();
  }

  // Also try with jQuery
  if (typeof jQuery !== 'undefined') {
    jQuery(document).ready(startInit);
    jQuery(window).on('load', startInit);
  }

  // Multiple fallback initializations
  setTimeout(startInit, 100);
  setTimeout(startInit, 500);
  setTimeout(startInit, 1000);
  setTimeout(startInit, 2000);
})();

